export function initThemeToggle() {
    const button = document.getElementById('gh-theme-toggle');
    if (!button) return;

    button.addEventListener('click', () => {
        const root = document.documentElement;
        const isDark = root.getAttribute('data-theme') === 'dark';
        if (isDark) {
            root.removeAttribute('data-theme');
            try { localStorage.setItem('ag-theme', 'light'); } catch (e) {}
        } else {
            root.setAttribute('data-theme', 'dark');
            try { localStorage.setItem('ag-theme', 'dark'); } catch (e) {}
        }
    });
}
